import styled from 'styled-components'

export const Container = styled.div`
  max-width: 1240px;
  width: 98%;
  margin: auto;
`

export const H2 = styled.h2`
  font-size: 36px;
  font-weight: 500;
  margin-bottom: 60px;
`
